import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { focuses } from "@/mocks/gossip";

export default function FocusSection() {
  return (
    <section id="focus" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          index="03"
          title="争议焦点盘点"
          subtitle="把这场热议拆成三个绕不开的问题，每个焦点都附上当前讨论的两种主要立场，方便你快速对齐信息。"
        />

        <div className="mt-9 grid grid-cols-1 gap-5 md:mt-12 lg:grid-cols-3 lg:gap-6">
          {focuses.map((item, idx) => (
            <Reveal key={item.title} delay={idx * 90}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
                <div className="relative h-44 w-full overflow-hidden md:h-48">
                  <img
                    src={item.cover}
                    alt={`${item.title} 相关的焦点配图`}
                    title={`${item.title} 骚女qq 争议焦点`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 rounded-md bg-background-50/95 px-2.5 py-1 text-[11px] font-bold tracking-wide text-primary-600">
                    {item.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5 md:p-6">
                  <h3 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-3 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {item.desc}
                  </p>
                  <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-4">
                    <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                      <i className="ri-discuss-line text-base text-secondary-500" />
                      {item.stat}
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 transition-transform group-hover:translate-x-0.5">
                      进入讨论
                      <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}